import React, { useEffect } from 'react';
import { useTranslation } from '@lt/localization';
import type { ReactNode } from 'react';
import styled from 'styled-components';
import { ActionItem } from '../ActionItem';

type Props = {
  onSendCode?: () => void;
  timeLeftToDeliver: number;
  SubmitComponent?: ReactNode;
  timer?: NodeJS.Timeout;
};

export const SendCodeAgainTimer = ({
  onSendCode,
  timeLeftToDeliver,
  SubmitComponent,
  timer,
}: Props) => {
  const { t } = useTranslation();

  useEffect(
    () => () => {
      if (timer) {
        clearInterval(timer);
      }
    },
    [],
  );

  return (
    <>
      {timeLeftToDeliver > 0 && (
        <Timer>
          {t('checkout.sendCode.timer', { time: timeLeftToDeliver })}
        </Timer>
      )}
      {timeLeftToDeliver < 1 &&
        (SubmitComponent || (
          <StyledActionItem onClick={onSendCode}>
            {t('checkout.sendCode.button')}
          </StyledActionItem>
        ))}
    </>
  );
};

const Timer = styled.div`
  font-size: 16px;
  line-height: 20px;
  color: #919499;
`;

const StyledActionItem = styled(ActionItem)`
  margin-top: 12px;
`;
